import { SEARCH_RESULTS_SETTINGS_KEYS } from './constants';
import { getSettingsDefaultValue, getSettingsValueOrDefault, } from './getSettingsValueOrDefault';
export function getSettingsValues(rawSettings) {
    var getSettingsRawValue = function (key) { return rawSettings[key]; };
    var getSettingsValue = rawSettings
        ? function (key) { return getSettingsValueOrDefault(key, getSettingsRawValue); }
        : getSettingsDefaultValue;
    return SEARCH_RESULTS_SETTINGS_KEYS.reduce(function (memo, key) {
        memo[key] = getSettingsValue(key);
        return memo;
    }, 
    // {} as Partial<ISearchResultsSettings>,
    {});
}
//# sourceMappingURL=getSettingsValues.js.map